'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: ', 'px;\n  left: ', 'px;\n  width: ', 'px;\n  height: ', 'px;\n  background-image: url(', ');\n  background-size: cover;\n  background-repeat: none;\n'], ['\n  position: absolute;\n  top: ', 'px;\n  left: ', 'px;\n  width: ', 'px;\n  height: ', 'px;\n  background-image: url(', ');\n  background-size: cover;\n  background-repeat: none;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ImageLayer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.y;
}, function (props) {
  return props.x;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.image;
});

/** @class ParallaxLayer
 * Renders a parallax scrolling image on the stage.
 * @prop {url} image - the image to display on stage
 * @prop {number} x - the horizontal position of the image on stage
 * @prop {number} y - the vertical position of the image on stage
 * @prop {number} width - the width of the image on stage
 * @prop {number} height - the height of the image on stage
 * @prop {number} ratio - the ratio at which this layer scrolls compared
 *   to the main layer.  Should be a float between 0 and 1.
 */

var ParallaxLayer = function (_Component) {
  _inherits(ParallaxLayer, _Component);

  function ParallaxLayer(props) {
    _classCallCheck(this, ParallaxLayer);

    return _possibleConstructorReturn(this, (ParallaxLayer.__proto__ || Object.getPrototypeOf(ParallaxLayer)).call(this, props));
  }

  _createClass(ParallaxLayer, [{
    key: 'render',
    value: function render() {
      var x = this.props.scrollDistance * (1 - this.props.ratio); //this.props.scrollPercent * (this.props.width - this.props.vw);
      var transform = 'translateX(' + x + 'px)';
      return _react2.default.createElement(ImageLayer, _extends({}, this.props, {
        style: { transform: transform },
        width: this.props.width,
        height: this.props.height }));
    }
  }]);

  return ParallaxLayer;
}(_react.Component);

exports.default = ParallaxLayer;


ParallaxLayer.propTypes = {
  image: _propTypes2.default.string.isRequired,
  x: _propTypes2.default.number.isRequired,
  y: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  ratio: _propTypes2.default.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/stage/parallax-layer.js
// module id = 1194
// module chunks = 0